import { mapGetters } from 'vuex'
// import { authorReviewReport } from '@/api/manuscript'
import { getUploadConfig } from '@/utils/upload'
import help from '@/utils/help'
import { openAuthor } from '@/api/open'
import customerReviewQuestion from '@/components/question.vue'

// import Loading from '../../upload-documents/loading.dialog'
export default {
  components: { customerReviewQuestion },
  data() {
    return {
      detail: {
        journal: {},
        questionList: {},
        reviewerFileList: [],
        type: {}
      },
      loading: false,
      params: {
        authorReply: '',
        authorReplyFileList: []
      },
      uploadProgress: {
        total: 0,
        current: 0
      },
      disableStatu: false,
      replayReport: true,
      reviewQuestion: true,
      commentsAuthor: true,
      rules: {}
    }
  },
  computed: {
    ...mapGetters({
      domain: 'getDomain'
    })
  },
  mounted() {
    const { id } = this.$route.query
    this.getQuery(id)
    this.getRules()
  },
  methods: {
    async getQuery(detailId) {
      let routeName = this.$route.name
      switch (routeName) {
        case '/author/submitted-author/report':
          this.disableStatu = false
          break
        case '/email-url/author-revise/reply':
          this.disableStatu = true
          break
        default:
          this.disableStatu = true
      }
      // this.detail = await authorReviewReport.query(detailId)
      this.detail = await openAuthor.authorReport(detailId)
      this.detail.questionList.forEach(item => {
        item.questionOptionObj = JSON.parse(JSON.stringify(item.questionOption))
      })
      const { id, version, authorReply, authorReplyFileList } = this.detail
      this.params = {
        id,
        version,
        authorReply,
        authorReplyFileList: authorReplyFileList || []
      }
      // console.log(this.params, 'this UI')
    },
    // 文件上传
    async handleUpload(files) {
      const types = [
        'pdf',
        'docx',
        'doc',
        'txt',
        'png',
        'jpg',
        'jpeg',
        'mp4',
        'mp3',
        'html',
        'xml',
        'mov',
        'xls',
        'xlsx',
        'zip',
        'tif',
        'tiff',
        'rtf'
      ]
      if (files.length === 1) {
        const file = files[0]
        let type = file.name.split('.')
        type = type[type.length - 1].toLowerCase()
        if (!types.includes(type)) {
          this.$message.error({
            title: 'Error',
            content: this.LANGUAGE[this.language].isWrongType
          })
          return false
        } else {
          this.addFile(file)
        }
      } else {
        files.forEach(file => {
          let type = file.name.split('.')
          type = type[type.length - 1].toLowerCase()
          if (types.includes(type)) {
            this.addFile(file)
          }
        })
      }
    },
    addFile(file) {
      const flag = this.params.authorReplyFileList.some(val => {
        if (file.name === val.name) {
          val = {
            name: file.name,
            size: file.size,
            sort: '',
            description: '',
            path: '',
            file: file,
            lastTime: this.$moment()
            // version: ''
          }
          return true
        }
      })
      if (!flag) {
        this.params.authorReplyFileList.push({
          name: file.name,
          size: file.size,
          sort: '',
          description: '',
          path: '',
          file: file,
          lastTime: this.$moment()
        })
      }
    },
    async download(file) {
      const url = file.path
        ? this.domain + '/' + file.path
        : window.URL.createObjectURL(file.file)
      help.download(url, file.name)
    },
    async submit() {
      // if (!this.params.authorReply) {
      //   this.$message.error({
      //     title: 'Error',
      //     content: 'Authors Response to reviewers cannot be empty!'
      //   })
      //   return
      // }
      const flag = this.$refs['author-reply-form'].validate()
      if (!flag) {
        return
      }
      if (
        this.params.authorReplyFileList &&
        this.params.authorReplyFileList.length
      ) {
        const path = `publisher/${this.publisherId}/manuscript/${
          this.detail.manuscriptId
        }/review-report/${this.detail.id}/${help.guid()}`

        this.uploadProgress = {
          current: 0,
          total: this.params.authorReplyFileList.length
        }
        const pro_all = []
        this.loading = true
        this.params.authorReplyFileList.forEach((item, index) => {
          if (!item.path) {
            pro_all[index] = getUploadConfig(item.file, path).then(res => {
              if (res && !res.includes('err:')) {
                this.uploadProgress.current++
              }
              return res
            })
          } else {
            this.uploadProgress.current++
          }
        })
        const reses = await Promise.all(pro_all)
        this.errArr = []
        reses.forEach(item => {
          if (item && item.includes('err:')) {
            this.errArr.push(item.split(':')[1])
          }
        })

        this.params.authorReplyFileList.forEach((item, index) => {
          if (!item.path && reses[index] && !reses[index].includes('err:')) {
            item.path = reses[index]
          }
          item.sort = index
        })

        if (this.errArr.length) {
          this.$message.error(this.LANGUAGE[this.language].uploadFileFail, 5)
          this.uploadProgress = {
            current: 0,
            total: 0
          }
          return
        }
      }

      // await authorReviewReport.add(this.params)
      await openAuthor.authorReportReply(this.params)
      this.loading = false
      this.$message.success({
        title: 'Success',
        content: 'Submit Successfully'
      })
      this.$router.back(-1)
    },
    cancel() {
      this.loading = false
    },
    delFile(index) {
      this.params.authorReplyFileList.splice(index, 1)
    },
    getRules() {
      this.rules = {
        authorReply: [
          {
            required: true,
            message: 'Authors Response to reviewers cannot be empty!'
          },
          {
            fun: this.checkAply,
            message: `Authors Response to reviewers cannot be empty!`
          }
        ]
      }
    }
  }
}
